import { render } from "./ChangePhotoOnFrontRecipe.vue?vue&type=template&id=34cb3ff2&scoped=true"
import script from "./ChangePhotoOnFrontRecipe.vue?vue&type=script&lang=js"
export * from "./ChangePhotoOnFrontRecipe.vue?vue&type=script&lang=js"

import "./ChangePhotoOnFrontRecipe.vue?vue&type=style&index=0&id=34cb3ff2&scoped=true&lang=css"
import "./ChangePhotoOnFrontRecipe.vue?vue&type=style&index=1&id=34cb3ff2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34cb3ff2"]])

export default __exports__